import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPolicyViolationsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8 4.888a2.721 2.721 0 1 1-5.441 0 2.721 2.721 0 0 1 5.442 0Zm.68 0a3.401 3.401 0 1 1-6.802 0 3.401 3.401 0 0 1 6.803 0ZM4.16 3.287a.34.34 0 0 0-.481.48l2.72 2.722a.34.34 0 1 0 .482-.481z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPolicyViolationsOutlined;
